import { Loader2 } from 'lucide-react';

export function StoreLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="w-16 h-16 animate-spin text-primary mx-auto" />
        <div className="space-y-2">
          <h2 className="font-display text-2xl font-bold text-foreground">
            Carregando Loja
          </h2>
          <p className="text-muted-foreground">
            Aguarde enquanto buscamos as informações...
          </p>
        </div>
      </div>
    </div>
  );
}
